import { Amount } from "./amount";

export enum WrapType {
  Wrapping = "Wrapping",
  Unwrapping = "Unwrapping",
}
export interface WrapQuote {
  type: WrapType;
  amount: Amount | undefined;
  max: boolean;
  gas: Amount;
  hash: string | undefined;
  warning: string | undefined;
  error: string | undefined;
}

export enum WrapQuoteStatus {
  PENDING_WALLET_CONFIRM = "PENDING_WALLET_CONFIRM",
  PROCESSING_TRANSACTION = "PROCESSING_TRANSACTION",
  USER_REJECTED_WRAP = "USER_REJECTED_WRAP",
  FAILED_WRAP = "FAILED_WRAP",
  COMPLETED = "COMPLETED",
}

export enum WrapStatus {
  ENTRY = "ENTRY",
  CONFIRMING = "CONFIRMING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  ERROR = "ERROR",
}
export const WrapWarningMessages = {
  WARNING:
    "We have auto calculated the max amount to be slightly less than your wallet balance to allow for the required network cost to process this transaction.",
};
